<template>
  <div class='faq-detail'>
    <el-breadcrumb separator=">">
      <el-breadcrumb-item class='link' @click.native='$emit("typeChange", type)'>{{briefName(type)}}</el-breadcrumb-item>
      <el-breadcrumb-item class='blue'>{{realName}}</el-breadcrumb-item>
    </el-breadcrumb>
    <article class='question-content'>
      <h1>{{realName}}</h1>
      <mavon-editor
        :value="content"
        :editable="false"
        :toolbarsFlag="false"
        :subfield="false"
        :boxShadow="false"
        previewBackground="#fff"
        placeholder=" "
        defaultOpen="preview"
        :imageClick="()=>{}"></mavon-editor>
    </article>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FAQ-Detail',
  props: {
    type: {
      required: true,
      type: String,
    },
    question: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      content: ''
    }
  },
  computed: {
    realName() {
      return this.briefName(this.question.slice(this.question.lastIndexOf('/') + 1));
    }
  },
  mounted() {
    axios.get(this.question).then(({data}) => {
      this.content = data;
    }) 
  }
}
</script>

<style lang="less" scoped>
.faq-detail {
  background: #fff;
  padding: 20px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #999;
  }
  /deep/ .blue .el-breadcrumb__inner {
    color: #718EFF;
  }
  /deep/ .link .el-breadcrumb__inner {
    cursor: pointer;
  }
  .question-content {
    > h1 {
      padding: 20px 0;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      border-bottom: 1px solid #cccccc;
      margin-bottom: 10px;
    }
    /deep/ .v-note-wrapper {
      min-height: 193px;
      &.markdown-body {
        color: #666;
      }
      .v-note-show .v-show-content {
        padding: 10px 0 !important;
      }
    }
  }
}
</style>